import React, { useState } from "react";
import {
  StyleSheet,
  View,
  Text,
  FlatList,
  Platform,
  Switch,
} from "react-native";

import { hasItems } from "../../../../helpers/utils";
import AppTheme from "../../AppTheme";
import IntegrationItem from "./IntegrationItem";
import appStyles from "../../../appStyles";
import IntegrationsHelper from "../IntegrationsHelper";

let IntegrationsList = (props) => {
  const { items, title = "", toggleAll = () => {}, controller } = props;

  const [isEnabled, setIsEnabled] = useState(
    props.isActive
      ? IntegrationsHelper.hasEnabledIntegrations(controller)
      : false,
  );

  const onToggleChanged = (value) => {
    setIsEnabled(value);
    toggleAll(value);
  };

  return !hasItems(items) ? null : (
    <View style={{ marginBottom: 16 }}>
      <View
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexDirection: "row",
        }}
      >
        <Text style={styles.headerText}>{title}</Text>

        {props.isActive ? (
          <View>
            <Switch
              value={isEnabled}
              onValueChange={onToggleChanged}
              thumbColor="#FFF"
              trackColor={{
                true: AppTheme.DEFAULT_COLOR,
                false: "#f3f2f1",
              }}
            />

            <Text style={[appStyles.captionThin, { textAlign: "center" }]}>
              {isEnabled ? "Syncing" : "Off"}
            </Text>
          </View>
        ) : null}
      </View>

      <View style={styles.listContainer}>
        <FlatList
          data={items}
          keyExtractor={(item) => item.id}
          renderItem={({ item }) => (
            <IntegrationItem
              controller={props.controller}
              item={item}
              {...props}
            />
          )}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  headerText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: "#8B92A1",
    paddingLeft: 6,
  },
  listContainer: {
    position: "relative",
    width: "100%",
    height: "auto",
    backgroundColor: "#fff",
    display: "flex",
    flexDirection: "column",
    borderWidth: 0,
  },
});

export default IntegrationsList;
